
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/galleries/preview",
      function () {
        return require("private-next-pages/galleries/preview/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/galleries/preview"])
      });
    }
  